import type { ReactNode } from "react";

// render children directly, accept ref for compatibility
export function ScrollContent({ children }: { children: ReactNode }) {
  return children;
}
